import { SxProps, Theme, Typography, TypographyProps } from '@mui/material';
import { forwardRef } from 'react';

interface Props extends Omit<TypographyProps, 'variant' | 'color'> {
  text: string;
  required?: boolean;
  sx?: SxProps<Theme> | undefined;
  adornment?: JSX.Element | null;
  textVariant?: any;
  color?: string;
}

const BaseInputLabel = forwardRef(
  (
    {
      text,
      required,
      sx,
      adornment = null,
      textVariant = 'heading5',
      color = 'primaryDark.500',
      ...rest
    }: Props,
    ref: any,
  ) => (
    <Typography
      ref={ref}
      variant={textVariant}
      color={color}
      sx={{
        whiteSpace: 'nowrap',
        display: 'flex',
        alignItems: 'center',
        mb: 1,
        ...sx,
      }}
      {...rest}
    >
      {/* {required && (
      <Typography color="secondaryBlue.700" sx={{ lineHeight: 1 }}>
        *&nbsp;
      </Typography>
    )} */}
      {text?.toUpperCase()}
      {adornment}
    </Typography>
  ),
);

export default BaseInputLabel;
